import { TDataRequirements } from '../NewDocUploads.types';
import AgedDebtorReport from './AgedDebtorReport';
import BankStatements from './BankStatements/BankStatements';
import CompanyAccounts from './CompanyAccounts';
import ManagementAccounts from './ManagementAccounts';
import SelfAssessmentTaxReturn from './SelfAssessmentTaxReturn';
import VATReturns from './VATReturns';

export const RequirementDetails = ({
    requirement,
    showStatus
}: {
    requirement: TDataRequirements[number];
    showStatus: boolean;
}) => {
    switch (requirement.type) {
        case 'bank_statement':
            return (
                <BankStatements
                    status={requirement.status}
                    // @ts-expect-error
                    quantifier={requirement.quantifier}
                    showStatus={showStatus}
                />
            );
        case 'vat_return':
            return (
                <VATReturns
                    // @ts-expect-error
                    quantifier={requirement.quantifier}
                    // @ts-expect-error
                    quantifier_unit={requirement.quantifier_unit}
                    showStatus={showStatus}
                    status={requirement.status}
                />
            );
        case 'company_accounts':
            return (
                <CompanyAccounts
                    // @ts-expect-error
                    quantifier={requirement.quantifier}
                    // @ts-expect-error
                    quantifier_unit={requirement.quantifier_unit}
                    showStatus={showStatus}
                    status={requirement.status}
                />
            );
        case 'management_accounts':
            return (
                <ManagementAccounts
                    showStatus={showStatus}
                    status={requirement.status}
                />
            );
        case 'self_assessment_tax_return':
            return (
                <SelfAssessmentTaxReturn
                    showStatus={showStatus}
                    status={requirement.status}
                />
            );
        case 'aged_debtor_report':
            return (
                <AgedDebtorReport
                    showStatus={showStatus}
                    status={requirement.status}
                />
            );
        default:
            return null;
    }
};
